import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { PublicBlogService } from '../../../_services/api/public/public-blog.service';
import { BlogList, BlogSearchCriteria } from '../../../_models/blogs/blog.model';
import { ApiResponse } from '../../../_models/api-response.model';
import { PublicBlogCard } from '../public-blog-card/public-blog-card';



@Component({
  selector: 'app-public-blogs-list',
  imports: [CommonModule, FormsModule, PublicBlogCard],
  templateUrl: './public-blogs-list.html',
  styleUrl: './public-blogs-list.scss',
})
export class PublicBlogsList {
  showFilterPopup: boolean = false;
  blogs: BlogList[] = [];
  isLoading = false;
  currentPage = 0;
  pageSize = 10;
  totalCount = 0;
  totalPages = 0;
  
  searchTerm = '';
  private searchSubject = new Subject<string>();
  selectedVisibility: string = 'all';
  selectedSort: string = 'createdAt,desc';
  private destroy$ = new Subject<void>();

  constructor(
      private blogService: PublicBlogService,    
      private router: Router,
      private route: ActivatedRoute
    ) {}
  
  ngOnInit(): void {
    this.setupSearch();
    this.loadBlogs();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupSearch(): void {
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.currentPage = 0;
      this.loadBlogs();
    });
  }

  onSearch(): void {
    this.searchSubject.next(this.searchTerm);
  }

  onFilterChange(): void {
    this.currentPage = 0;
    this.loadBlogs();
  }

  onSortChange(): void {
    this.currentPage = 0;
    this.loadBlogs();
  }

  loadBlogs(): void {
    this.isLoading = true;
    
    const criteria: BlogSearchCriteria = {};
    if (this.searchTerm.trim()) {
      criteria.search = this.searchTerm.trim();
    }

    const [sortField, sortDirection] = this.selectedSort.split(',');
    this.blogService.getPublicBlogs(criteria, this.currentPage, this.pageSize, sortField, sortDirection)
      .subscribe({
        next: (response: ApiResponse<any>) => {
          this.blogs = response.data?.content || [];
          this.totalCount = response.data?.totalElements || 0;
          this.totalPages = response.data?.totalPages || 0;
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
        error: (error) => {
          console.error('Error loading blogs:', error);
          this.isLoading = false;
        }
      });
  }

  toggleFilterPopup() {
    this.showFilterPopup = !this.showFilterPopup;
  }

  closeFilterPopup(event: Event) {
    if ((event.target as HTMLElement).classList.contains('filter-overlay')) {
      this.showFilterPopup = false;
    }
  }
}
